import { Component } from "../../core/Component";
const FORM_STYLE = {
  0: "qform-default",
  // 0: Поля с обводкой
  1: "qform-background",
  // 1: Поля с фоном
  2: "qform-underline",
  // 2: Поля с подчеркиванием
  3: "qform-default-background",
  // 3: Поля с фоном и обводкой
  4: "qform-underline-background" // 4: Поля с фоном и подчеркиванием
};
const FIELD_SIZE = {
  0: "qform-size-sm",
  1: "qform-size-md",
  2: "qform-size-lg"
};
const FIELD_RADIUS = {
  0: "qform-radius-0px",
  1: "qform-radius-5px",
  2: "qform-radius-25px"
};
export class BtnModalComponent extends Component {
  // static className = "btn_modal-box";
  constructor($root, options) {
    super($root, options);
    this.options = options;
    this.openButton = options.openButton || false;
    this.type = options.type || "submit";
    this.classes = options.classes || "";
    this.name = `btn-modal`;
    this.id = `btn-modal_${options.formId}_${options.formIndex}`;
    this.idModal = `modal_${options.formId}_${options.formIndex}`;
    this.idBtnModalBox = `btn_modal-box_${options.formId}_${options.formIndex}`;
    this.idModalBtnClose = `modal_${options.formId}_${options.formIndex}_btn-close`;
    this.value = /* this.openButton.text */options.buttonText || `Открыть форму`;
    this.formPicturePosition = options.formPicturePosition;
    this.formType = options.formType; // 'form' || 'quiz'
    this.Emitter = options.Emitter;
  }
  toHTML() {
    return `
      <input
        type="button"
        value="${this.value}"
        name="${this.name}"
        id="${this.id}"
        class="btn-modal ${this.classes}"
      >
    `;
  }
  async init() {
    this.$input = this.$root.$el.querySelector(`#${this.id}`);
    this.$modal = document.getElementById(`${this.idModal}`);
    document.body.appendChild(this.$modal);
    this.$btnModalBox = document.getElementById(`${this.idBtnModalBox}`);
    this.$modalForm = this.$modal.querySelector('.form-modal');
    if (this.formType === 'form') {
      this.$picture = this.$modal.querySelector('.is_qform-picture-container');
    }
    this.initModalCloseBtn();
    if (this.$input) {
      this.listeners = [{
        eventName: "click",
        method: "onClick",
        el: this.$input
      }, {
        eventName: "click",
        method: "onClickClose",
        el: this.$modalBtnClose
      }, {
        eventName: "click",
        method: "onClickOverlay",
        el: this.$modal
      }];
    }
    super.init();
  }
  initModalCloseBtn() {
    this.$modalBtnClose = document.getElementById(`${this.idModalBtnClose}`);
    this.listeners = [];
    this.listeners.push({
      eventName: "click",
      method: "onClickClose",
      el: this.$modalBtnClose
    });
    this.initDomListener();
  }
  onClick(event) {
    event.preventDefault();
    event.stopPropagation();
    this.$modal.classList.toggle("hidden");
    document.body.classList.toggle("overflowHidden");
    const imgPositions = ["right", "left", "top", "bottom", "background"];
    const img_position = imgPositions[this.formPicturePosition - 1];

    //сохраняем значение высоты формы при первичной отрисовке
    if (!this.modalFormHeight) {
      this.modalFormHeight = this.$modalForm.clientHeight;
    }
    if (this.formType === 'form') {
      if (img_position !== "background") {
        if (img_position == "left" || img_position == "right") {
          if (window.innerWidth < 425) {
            //устанавливаем высоту, равную высоте формы (ограничена 50vh)
            this.$picture.style.height = this.modalFormHeight + "px";
          }
        } else {
          //устанавливаем высоту, равную высоте формы (ограничена 50vh)
          this.$picture.style.height = this.modalFormHeight + "px";
        }
      }
    } else {
      this.Emitter.emit('setQuizPictureHeight');
    }
    this.Emitter.emit('openModal');
  }
  onClickClose() {
    this.closeModal();
  }
  onClickOverlay(event) {
    event.stopPropagation();
    //обрабатываем закрытие модального окна при клике на overlay
    if (event.target.className.includes('form-overlay')) {
      this.closeModal();
    }
  }
  closeModal() {
    this.$modal.classList.add("hidden");
    document.body.classList.remove("overflowHidden");
    this.Emitter.emit('closeModal');
  }
  setClassField(data) {
    let styleHover = {
      0: 'shadow',
      1: 'arrow',
      2: '',
      3: 'opacity'
    };
    // Стиль формы
    if (data.formStyleCommon && typeof data.formStyleCommon.fieldStyle !== "undefined" && FORM_STYLE[data.formStyleCommon.fieldStyle]) {
      this.$btnModalBox.classList.add(FORM_STYLE[data.formStyleCommon.fieldStyle]);
    }
    // Темная тема формы
    if (data.formStyleCommon && data.formStyleCommon.theme) {
      this.$modal.classList.add('qform-theme-black');
      this.$btnModalBox.classList.add('qform-theme-black');
    }
    // Размер полей
    if (data.formStyleCommon && typeof data.formStyleCommon.fieldSize !== "undefined" && FIELD_SIZE[data.formStyleCommon.fieldSize]) {
      this.$btnModalBox.classList.add(FIELD_SIZE[data.formStyleCommon.fieldSize]);
    }
    // Border-radius полей
    if (data.formStyleCommon && typeof data.formStyleCommon.fieldRounding !== "undefined" && FIELD_RADIUS[data.formStyleCommon.fieldRounding]) {
      this.$btnModalBox.classList.add(FIELD_RADIUS[data.formStyleCommon.fieldRounding]);
    }
    //Стили при наведении
    if (this.options.buttonHoverStyle !== undefined && this.options.buttonHoverStyle !== 2) {
      if (this.options.buttonHoverStyle == 1) {
        this.$btnModalBox.classList.add(`qform-hover-arrow`);
      } else {
        this.$input.classList.add(`qform-hover-${styleHover[this.options.buttonHoverStyle]}`);
      }
    }
  }
  validation() {
    return true;
  }
}